var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.49 21.38l1.049-6.818h-6.587V10.13c0-1.875.952-3.701 3.88-3.701h2.976V.633s-2.684-.487-5.27-.487c-5.417 0-8.93 3.287-8.93 9.205v5.211H.558v6.819h6.05v16.534c1.196.195 2.44.292 3.684.292 1.245 0 2.49-.097 3.684-.292V21.381h5.514z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjEgMzkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTkuNDkwNSAyMS4zODA3TDIwLjUzODkgMTQuNTYyMUgxMy45NTE2VjEwLjEyOTlDMTMuOTUxNiA4LjI1NTQxIDE0LjkwMzYgNi40Mjg3OCAxNy44MzEzIDYuNDI4NzhIMjAuODA3NlYwLjYzMzE1MUMyMC44MDc2IDAuNjMzMTUxIDE4LjEyMzkgMC4xNDU5OTYgMTUuNTM3NCAwLjE0NTk5NkMxMC4xMjEzIDAuMTQ1OTk2IDYuNjA4MzggMy40MzMyOSA2LjYwODM4IDkuMzUwOTFWMTQuNTYyMUgwLjU1NzYxN1YyMS4zODA3SDYuNjA4MzhWMzcuOTE1MkM3LjgwMzU0IDM4LjEwOTggOS4wNDgxNCAzOC4yMDcgMTAuMjkxOSAzOC4yMDdDMTEuNTM2NSAzOC4yMDcgMTIuNzgxMSAzOC4xMDk4IDEzLjk3NjMgMzcuOTE1MlYyMS4zODA3SDE5LjQ5MDVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgFacebookLogo as ReactComponent };